import { BufferTarget, MediaStreamAudioTrackSource, Output, WavOutputFormat } from "mediabunny";

export interface WavRecorder {
  stop: () => Promise<Blob | null>;
}

export async function startWavRecorder(stream: MediaStream, sampleRate: number): Promise<WavRecorder> {
  const track = stream.getAudioTracks()[0];
  if (!track) {
    throw new DOMException("No audio track in the stream", "NotFoundError");
  }

  const target = new BufferTarget();
  const output = new Output({ format: new WavOutputFormat(), target });
  output.addAudioTrack(new MediaStreamAudioTrackSource(track, { codec: "pcm-s16", transform: { numberOfChannels: 1, sampleRate } }));
  await output.start();

  return {
    stop: async () => {
      await output.finalize();
      return target.buffer ? new Blob([target.buffer], { type: "audio/wav" }) : null;
    },
  };
}
